import React from "react";

import CheckIcon from "@mui/icons-material/Check";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import MaterialThumbnail from "components/subComponents/MaterialThumbnail";
import SearchInput from "components/ui/SearchInput";

import { ProductMaterialSelectionHook } from "hooks/form/useProductMaterialSelectionForm";

function MaterialSelectionPanel({
    selectionHook,
}: {
    selectionHook: ProductMaterialSelectionHook;
}) {
    const {
        categories,
        activeCategory,
        selectCategory,
        searchTerm,
        setSearchTerm,
        visibleMaterials,
        loading,
        isChecked,
        toggleMaterial,
        allVisibleChecked,
        toggleSelectAllVisible,
        hasSelection,
    } = selectionHook;

    const onSearchChange = React.useCallback(
        (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            setSearchTerm(event.target.value);
        },
        [setSearchTerm],
    );

    return (
        <GridRow>
            <GridColumn className={"material-picker-sidebar"}>
                <h2 className={"material-picker-sidebar-title"}>Materiali</h2>

                {categories.map((category) => (
                    <button
                        key={category.id}
                        type={"button"}
                        className={`material-picker-sidebar-item ${
                            activeCategory?.id === category.id ? "active" : ""
                        }`}
                        onClick={() => selectCategory(category)}
                    >
                        {hasSelection(category.id) && (
                            <span className={"material-picker-sidebar-dot"} />
                        )}

                        {category.name}
                    </button>
                ))}
            </GridColumn>

            <GridItem className={"material-picker-content"}>
                <GridRow className={"material-picker-toolbar"} alignItems={"center"}>
                    <button
                        type={"button"}
                        className={"material-picker-select-all"}
                        onClick={toggleSelectAllVisible}
                    >
                        {allVisibleChecked ? "Deseleziona tutti i materiali" : "Tutti i materiali"}
                    </button>

                    <SearchInput
                        placeholder={"Cerca..."}
                        value={searchTerm}
                        onChange={onSearchChange}
                    />
                </GridRow>

                {!activeCategory && (
                    <p>Seleziona una categoria di materiali dall'elenco a sinistra.</p>
                )}

                {activeCategory && loading && <p>Caricamento...</p>}

                {activeCategory && !loading && (
                    <GridItem className={"material-picker-grid"}>
                        {visibleMaterials.map((material) => (
                            <GridColumn
                                className={`material-picker-tile ${
                                    isChecked(material.id) ? "checked" : ""
                                }`}
                                key={material.id}
                            >
                                <GridItem className={"material-picker-thumb-wrapper"}>
                                    <MaterialThumbnail
                                        imageId={material.mb_mobile_thumb_id}
                                        filename={material.mb_mobile_thumb_filename}
                                        alt={`${material.art_rr} - ${material.code_rr}`}
                                    />

                                    <button
                                        type={"button"}
                                        className={`material-picker-checkbox-overlay ${
                                            isChecked(material.id) ? "checked" : ""
                                        }`}
                                        aria-pressed={isChecked(material.id)}
                                        aria-label={material.name ?? "Seleziona materiale"}
                                        onClick={() => toggleMaterial(material.id)}
                                    >
                                        {isChecked(material.id) && <CheckIcon />}
                                    </button>
                                </GridItem>

                                <span className={"material-picker-tile-name"}>
                                    {`${material.art_rr} - ${material.code_rr}`}
                                </span>
                            </GridColumn>
                        ))}
                    </GridItem>
                )}
            </GridItem>
        </GridRow>
    );
}

export default MaterialSelectionPanel;
